module.exports = __webpack_public_path__ + "static/media/calendar-previous.79ad36ba.svg";